export default __webpack_public_path__ + "static/media/s3.a2b2e68e.png";